/* ============================================================
   Numa Cart Drawer — UpCart-style behaviour
   Slide-out · inline AJAX (no reload) · straight to checkout
   ============================================================ */
(function () {
  'use strict';

  var overlay  = document.getElementById('ncdOverlay');
  var drawer   = document.getElementById('ncdDrawer');
  if (!drawer || !overlay) return;

  var closeBtn = document.getElementById('ncdClose');
  var itemsEl  = document.getElementById('ncdItems');
  var countEl  = document.getElementById('ncdCount');
  var footerEl = document.getElementById('ncdFooter');
  var subtotalEl = document.getElementById('ncdSubtotal');
  var checkoutTotalEl = document.getElementById('ncdCheckoutTotal');
  var rewardMsgEl = document.getElementById('ncdRewardMsg');
  var barFillEl = document.getElementById('ncdBarFill');

  var THRESH = window.numaFreeShipThreshold || 9000;
  var PDP    = window.numaPdpUrl || '/';
  var LOWSTOCK = window.numaLowStock || {};
  var COMPARE = window.numaCompareAt || {};

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = window.numaMoneyFormat || '${{amount}}';
    var amt = (cents || 0) / 100.0;
    function commas(s) { return s.replace(/(\d)(?=(\d{3})+\.)/g, '$1,'); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      if (key === 'amount_no_decimals') return commas(Math.round(amt).toFixed(0) + '.').slice(0, -1);
      return commas(amt.toFixed(2));
    });
  }

  /* ---------- open / close ---------- */
  function open() {
    overlay.hidden = false; drawer.hidden = false;
    /* force reflow so the transition runs from hidden state */
    void drawer.offsetWidth;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  closeBtn && closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- render ---------- */
  function itemHTML(it) {
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    var variant = (it.variant_title && it.variant_title !== 'Default Title')
      ? '<div class="ncd-item-variant">' + esc(it.variant_title) + '</div>' : '';
    var cmpUnit = COMPARE[it.variant_id];
    var cmpLine = (cmpUnit != null) ? cmpUnit * it.quantity : 0;
    var save = (cmpLine > it.final_line_price)
      ? '<div class="ncd-item-save">Save ' + formatMoney(cmpLine - it.final_line_price) + '</div>' : '';
    var low = LOWSTOCK[it.variant_id];
    var stock = (low != null && low > 0)
      ? '<div class="ncd-item-stock">Only ' + low + ' left in stock</div>' : '';
    var compare = (cmpLine > it.final_line_price)
      ? '<span class="ncd-price-compare">' + formatMoney(cmpLine) + '</span>' : '';
    return '' +
      '<div class="ncd-item" data-key="' + esc(it.key) + '">' +
        '<a class="ncd-item-img" href="' + esc(it.url) + '">' +
          (img ? '<img src="' + esc(img) + '" width="72" height="72" loading="lazy" alt="' + esc(it.product_title) + '">' : '') +
        '</a>' +
        '<div class="ncd-item-main">' +
          '<div class="ncd-item-titlerow">' +
            '<span class="ncd-item-title">' + esc(it.product_title) + '</span>' +
            '<button class="ncd-remove" data-key="' + esc(it.key) + '" type="button" aria-label="Remove">' +
              '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button>' +
          '</div>' +
          variant + save + stock +
          '<div class="ncd-item-bottom">' +
            '<div class="ncd-qty">' +
              '<button type="button" data-action="decrease" data-key="' + esc(it.key) + '" aria-label="Decrease quantity">−</button>' +
              '<span class="ncd-qty-val">' + it.quantity + '</span>' +
              '<button type="button" data-action="increase" data-key="' + esc(it.key) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="ncd-item-price">' + compare +
              '<span class="ncd-price-final">' + formatMoney(it.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function syncHeaderBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        icon.appendChild(bubble);
      }
      var span = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (span) span.textContent = count < 100 ? count : '';
    } else if (bubble) {
      bubble.remove();
    }
  }

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    syncHeaderBubble(cart.item_count);

    /* reward bar */
    if (cart.total_price >= THRESH) {
      rewardMsgEl.innerHTML = '<span class="ncd-reward-won">You’ve unlocked <b>free shipping</b></span>';
    } else {
      rewardMsgEl.innerHTML = 'You’re <b class="highlight">' + formatMoney(THRESH - cart.total_price) +
        '</b> away from <b>free shipping</b>';
    }
    var pct = Math.min(100, Math.round((cart.total_price * 100) / THRESH));
    if (barFillEl) barFillEl.style.width = pct + '%';

    /* items */
    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div class="ncd-empty" id="ncdEmpty">' +
          '<svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="' + esc(PDP) + '">Shop the Care of June Strap</a>' +
        '</div>';
      footerEl && footerEl.classList.add('is-hidden');
    } else {
      itemsEl.innerHTML = cart.items.map(itemHTML).join('');
      footerEl && footerEl.classList.remove('is-hidden');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(cart.total_price);
      /* subtotal Save badge (compare-at based, matches SSR) */
      var compareTotal = 0;
      cart.items.forEach(function (it) {
        var c = COMPARE[it.variant_id];
        compareTotal += (c != null && c * it.quantity > it.final_line_price) ? c * it.quantity : it.final_line_price;
      });
      var right = footerEl.querySelector('.ncd-subtotal-right');
      var existing = right.querySelector('.ncd-subtotal-save');
      if (compareTotal > cart.total_price) {
        var html = '<span class="ncd-subtotal-save">Save ' + formatMoney(compareTotal - cart.total_price) + '</span>';
        if (existing) existing.outerHTML = html; else right.insertAdjacentHTML('afterbegin', html);
      } else if (existing) { existing.remove(); }
    }
  }

  /* ---------- cart API ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refresh() { return fetchCart().then(render); }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function addItem(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) {
            var err = new Error('atc ' + r.status);
            err.userMessage = (body && (body.description || body.message)) || 'Could not add - please try again';
            throw err;
          }
          return body;
        });
      })
      .then(function () { return refresh(); })
      .then(open);
  }

  /* expose for numa-atc.js and other triggers */
  window.numaCartDrawer = { open: open, close: close, addItem: addItem, refresh: refresh };

  /* ---------- delegated events (survive re-render) ---------- */
  itemsEl.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('.ncd-qty button');
    if (qtyBtn) {
      var row = qtyBtn.closest('.ncd-item');
      var key = qtyBtn.getAttribute('data-key');
      var cur = parseInt(row.querySelector('.ncd-qty-val').textContent, 10) || 0;
      var next = qtyBtn.getAttribute('data-action') === 'increase' ? cur + 1 : cur - 1;
      if (next < 0) next = 0;
      changeQty(key, next);
      return;
    }
    var rm = e.target.closest('.ncd-remove');
    if (rm) { changeQty(rm.getAttribute('data-key'), 0); }
  });

  /* ---------- checkout: straight to checkout, skip cart page ---------- */
  var checkoutBtn = document.getElementById('ncdCheckout');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      checkoutBtn.style.opacity = '.7';
      window.location.href = '/checkout';
    });
  }

  /* ---------- intercept every cart trigger → open drawer (never /cart) ---------- */
  function bindCartTriggers() {
    var sels = '#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], .cart-icon-bubble, [data-numa-cart-open]';
    document.querySelectorAll(sels).forEach(function (el) {
      if (el.__numaBound) return; el.__numaBound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        refresh(); open();
      });
    });
  }
  bindCartTriggers();
  document.addEventListener('DOMContentLoaded', bindCartTriggers);

  /* ---------- auto-open after ATC reload fallback ---------- */
  if (sessionStorage.getItem('numa_open_cart')) {
    sessionStorage.removeItem('numa_open_cart');
    refresh(); open();
  }
})();
